import { render, staticRenderFns } from "./app_config.vue?vue&type=template&id=0a8c2262&"
import script from "./app_config.vue?vue&type=script&lang=js&"
export * from "./app_config.vue?vue&type=script&lang=js&"
import style0 from "./app_config.vue?vue&type=style&index=0&id=0a8c2262&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports